export default __webpack_public_path__ + "static/media/accountingfirmplan.c0c62346.png";